import React from 'react'
import { Document, Page, StyleSheet, View, Text, Image } from "@react-pdf/renderer";
import getLogo from './getLogo'

const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    justifyContent: 'space-between',
    backgroundColor: 'white',
    fontSize: '10pt',
    padding: '2cm',
    textAlign: 'justify'
  },
  logo: {
    width: 50,
    height: 50,
  },
  title:{
    fontSize: '14pt',
  },
  data: {
    color: 'darkblue'
  },
  row: {
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    maxWidth: '100%',
    marginBottom: 4,
  },
  content:{
    lineHeight: '2pt',
  },
  field: {
    fontSize: '11pt',
    color: 'darkblue'
  },
  center:{
    textAlign: 'center',
  }
});



const tclePdf = ({ nome, data, cpf, procedimentos, cirurgiao, cidade, estado,
                   nomeExibicao, crm, groupName, logoName}) => (

<Document title="APA" author={nome} creator="www.avaliacaopreanestesica.com">
  <Page style={styles.page} wrap={false}>
    <View style={styles.row}>
        <View><Image style={styles.logo} src={getLogo(logoName)}/></View>
        <View style={styles.center}>
          <Text style={styles.title}>TERMO DE CONSENTIMENTO LIVRE E ESCLARECIDO</Text>
          <Text style={styles.title}>PARA PROCEDIMENTO ANESTÉSICO</Text>
          </View>
    </View>

    <View>
      <Text style={styles.content}>
Considerando o art.59 do Código de Ética Médica e os artigos 6º III e 39º VI da Lei 8.078/90 do Código de Defesa do Consumidor, que garantem ao paciente a plena informação sobre seu estado de saúde, eu, <Text style={styles.field}>{nome}</Text>, CPF nº <Text style={styles.field}>{cpf}</Text>, em pleno gozo de minhas faculdades mentais, AUTORIZO o(s) médico(s) anestesiologista(s) responsável(is) pela minha assistência, a efetuar os procedimentos anestésicos necessários para o(s) seguinte(s) procedimento(s) cirúrgico(s) ao(s) qual(is) concordei em ser submetido:
      </Text>
      <Text style={[styles.field, {marginBottom: 10, textAlign: 'center'}]}>
        {procedimentos}
      </Text>
      <Text style={styles.content}>

Confirmo que fui atendido em consulta {nomeExibicao && `por ${nomeExibicao}` } {crm && ` CRM: ${crm}`} e recebi, neste momento, todas as informações necessárias sobre o procedimento anestésico e todos os riscos inerentes a esse procedimento além dos possíveis efeitos colaterais e complicações, tais como febre, dor de cabeça, tremores, alterações do comportamento, reações alérgicas e reações anafiláticas, algumas potencialmente fatais. Estou ciente que, caso haja alguma eventual complicação, outros procedimentos médicos poderão ser necessários, inclusive transfusão sanguínea, ficando estes desde já pré-autorizados. Nessa situação, serei avaliado e acompanhado pelo médico, sendo que autorizo a realização de outro procedimento, exame ou tratamento em situações imprevistas que possam ocorrer durante o presente procedimento e que necessitem de cuidados especializados diferentes daqueles inicialmente propostos; tal conduta para afastar os riscos prejudiciais à saúde e à vida.

A fim de prevenir e afastar eventuais problemas, declaro também que prestei ao Médico Anestesiologista todas as informações necessárias ao pleno conhecimento deste acerca de minhas condições físicas e psicológicas, sem ocultar qualquer fato ou elemento. Todavia, em se tratando de procedimento médico, restam presentes os riscos inerentes e naturais ao ato anestésico.

Confirmo que todas as minhas dúvidas foram sanadas e compreendo que o médico anestesiologista somente se responsabiliza pelos procedimentos de sua especialidade. A presente declaração foi lida e compreendida em todos os seus termos, inclusive da opção de revogação desta, caso não queira mais autorizar o procedimento.
      </Text>
    </View>
    <View style={styles.center}>
      <Text>
        ______________________________________________________________
      </Text>
      <Text>
        ASSINATURA DO PACIENTE
      </Text>
    </View>
    <View style={styles.center}>
      <Text>
        ______________________________________________________________
      </Text>
      <Text>
        ASSINATURA DO MÉDICO ANESTESIOLOGISTA
      </Text>
      <Text>
        {groupName ? groupName : (nomeExibicao ? nomeExibicao : '')}
        {!groupName && crm && ` CRM: ${crm}`}
      </Text>
    </View>
    <View style={styles.center}>
      <Text style={styles.data}>
        {cidade && `${cidade}/${estado},`} {data.toDate().toLocaleString('pt-BR', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
})}
      </Text>
    </View>
  </Page>
</Document>
);

export default tclePdf
